import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { CrmPipelinesResponse } from '../model/types';

export const getCrmPipelinesAPI = async () => {
  const response = await baseAPI.get<CrmPipelinesResponse>(
    '/portal-digest/crm/pipelines',
  );
  return response.data;
};

export const useGetCrmPipelines = () => {
  return useQuery({
    queryKey: [KEYS.PORTAL_DIGEST_PIPELINES],
    queryFn: () => getCrmPipelinesAPI(),
    staleTime: 1000 * 60 * 5, // pipelines change rarely
    retry: false,
  });
};
